module.exports = __webpack_public_path__ + "static/media/foodshot1.b69698dc.JPG";